export default __webpack_public_path__ + "static/media/logo-dataset-light.488035ff.svg";